// ----------------------------------------------------------------------

// Each deploy replaces assets/: a tab opened before it asks for chunks that no longer exist.
// One reload fetches the new index.html; the guard stops a loop when the chunk is really missing.
const RELOAD_KEY = 'heyjob:stale-chunk-reload-at';
const RELOAD_GUARD_MS = 10000;

function reloadedRecently() {
  const last = Number(window.sessionStorage.getItem(RELOAD_KEY));
  return Number.isFinite(last) && Date.now() - last < RELOAD_GUARD_MS;
}

export function reloadOnStaleChunk() {
  window.addEventListener('vite:preloadError', (event) => {
    try {
      if (reloadedRecently()) return;
      window.sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
    } catch (error) {
      // Without sessionStorage the guard cannot work: keep the error visible.
      return;
    }
    event.preventDefault();
    window.location.reload();
  });
}
